import { render } from "./ProgressClock.vue?vue&type=template&id=19739ce9"
import script from "./ProgressClock.vue?vue&type=script&lang=js"
export * from "./ProgressClock.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__